import {
  LicensePackage,
  LicensePackageCode,
  IAccount,
} from '@account-users/account/models';
import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-account-trial-upgrade-modal',
  templateUrl: './account-trial-upgrade-modal.component.html',
  styleUrls: ['./account-trial-upgrade-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AccountTrialUpgradeModalComponent implements OnInit {
  @Input() public set licensePackages(licensePackages: LicensePackage[]) {
    this._licensePackages = licensePackages?.filter(
      (p) => p.code !== LicensePackageCode.Trial,
    );
  }
  @Input() accountDetails: IAccount;
  @Output() upgradeTrial = new EventEmitter<{
    accountId: string;
    subscriptionId: string;
    orderNumber: string;
    licensePackage: string;
  }>();

  public form: FormGroup;
  private _licensePackages: LicensePackage[];

  public get licensePackages() {
    return this._licensePackages;
  }

  public get subscriptionId() {
    return this.form.get('subscriptionId');
  }

  public get orderNumber() {
    return this.form.get('orderNumber');
  }

  constructor(
    public readonly activeModal: NgbActiveModal,
    private readonly fb: FormBuilder,
  ) {
    this.form = this.fb.group({
      subscriptionId: [
        '',
        [Validators.required, Validators.pattern(/^[A-Za-z0-9]{16}$/)],
      ],
      licensePackage: [[], Validators.required],
      orderNumber: [
        '',
        [Validators.required, Validators.pattern(/^[A-Za-z0-9]{16}$/)],
      ],
    });
  }

  ngOnInit(): void {
    const { sbmRef } = this.accountDetails ?? {};
    this.form.patchValue({
      subscriptionId: sbmRef,
      licensePackage: this._licensePackages[0]?.code ?? '',
    });
  }

  public upgrade() {
    this.activeModal.close();
    const { licensePackage, orderNumber, subscriptionId } = this.form.value;
    this.upgradeTrial.emit({
      accountId: this.accountDetails.id,
      licensePackage,
      orderNumber,
      subscriptionId,
    });
  }
}
